import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {OrderAssignmentRuleData} from "./order-assignment-rule.data";

@Injectable()
export class OrderAssignmentRuleEntityModel extends EntityModel<OrderAssignmentRuleData> {

    constructor(injector: Injector) {
        super(injector, OrderAssignmentRuleData);
    }
}
